export type { PhotoEditMainProps } from "./photo-edit-main.interface";
export { PhotoEditMain } from "./photo-edit-main";
